import { useCallback, useMemo, useState } from "react";
import api from "../../../../utils/api";
import { Checkin } from "../../../../types";
import { TMensagem } from "../children/services";
import useLoading from "../../../../hooks/useLoading";
import { useErrorSuccess } from "../../../../hooks/useErrorSuccess";

interface GetMembrosProps {

}

export type ResponseMembrosCheckin = {
  listAll: Checkin[] | [],
  clearMensagem: VoidFunction
  reset: VoidFunction
  handleSubmit: () => Promise<void>
  nextPagina: VoidFunction
  getWithParams: (params: any) => void
  mensagem: TMensagem
  pagina: number,
  getSearchName: (e: any) => void
  nome: string | undefined
  alterMensagem: (field: keyof TMensagem, value: any) => void
}

const GetMembros = (): ResponseMembrosCheckin => {

  const { isLoading, startLoading, stopLoading } = useLoading();
  const { setMensagemSuccess, setMensagemError } = useErrorSuccess()

  const [listCheckinMembros, setListCheckinMembros] = useState<Checkin[]>([]);
  const [mensagem, setMensagem] = useState<TMensagem>({ tipo: 'Agendamento' });
  const [pagina, setPagina] = useState<number>(0);
  const [nome, setNome] = useState<string>();

  const getSearchName = (e: any) => setNome(e?.target?.value);

  const nextPagina = useCallback(() => {
    setPagina((pagina) => pagina + 1)
  }, [pagina]);

  const reset = async () => {
    await getList()
  }

  const alterMensagem = (field: keyof TMensagem, value: any) => setMensagem((mensagem) => ({...mensagem, [field]: value}))

  const clearMensagem = () => {
    setMensagem(undefined);
  }

  const getWithParams = (params: any) => {
    api.get<Checkin[]>('agendamento/bot', { params: { ...params } })
      .then(
        (sucesso) => {
          setListCheckinMembros(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {
          console.log(error?.response);
        }
      )
  }

  const handleSubmit = async () => {
    if(isLoading) return;
    startLoading();
    try {
      const req = await api.post('agendamento/bot', mensagem);
      const res = await req.data;
      setMensagemSuccess('Criado com sucesso!');

    } catch (error) {
      setMensagemError(JSON.stringify(error?.response?.data, null, 2));
    } finally {
      await getList();
      stopLoading();
    }
  }

  const getList = useCallback(async () => {
    api.get<Checkin[]>('agendamento/bot')
      .then(
        (sucesso) => {
          setListCheckinMembros(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {
          console.log(error?.response);
        }
      )
  }, []);

  useMemo(() => {
    getList()
  }, [])


  return {
    listAll: listCheckinMembros,
    reset,
    mensagem,
    nextPagina,
    clearMensagem,
    pagina,
    getWithParams,
    getSearchName,
    nome,
    alterMensagem,
    handleSubmit
  };
}

export default GetMembros;
